import React from 'react';

/**
 * A Home section's heading: the serif title, one line that says what the
 * section is for (a Home section earns its subtitle — four sections of
 * cards need telling apart), and a right-side action (SeeAllLink, chips).
 * Sections sit flat on the page, separated by space and this header.
 */
export default function HomeSectionHeader({ title, subtitle = null, action = null, id }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4">
      <div className="min-w-0">
        <h2 id={id} className="font-display font-medium text-xl md:text-2xl leading-snug text-content-primary">{title}</h2>
        {subtitle && <p className="mt-0.5 text-sm text-content-secondary">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0 flex items-center gap-2">{action}</div>}
    </div>
  );
}
